// Runtime configuration

export interface OpsConfig {
  authApiUrl: string;
  opsApiUrl: string;
  isMock: boolean;
}

let _config: OpsConfig | null = null;

export function getConfig(): OpsConfig {
  if (_config) return _config;

  const isLocal = window.location.hostname === 'localhost';

  _config = {
    authApiUrl: isLocal
      ? 'https://auth.kaiandco.ai'
      : 'https://auth.kaiandco.ai',
    opsApiUrl: isLocal
      ? '' // Use Vite proxy
      : 'https://ops.kaiandco.io',
    isMock: isLocal,
  };

  return _config;
}
